import jwt_decode from "jwt-decode";

const jwt = {
    getToken: function (){
        return localStorage.getItem("token");
    },
    setToken: function(token) {
        localStorage.setItem("token", token);
    },
    removeToken: function() {
        localStorage.removeItem('token');
    },
    getTokenExpirationTimestamp: function(token) {
        try {
            const decodedToken = jwt_decode(token)
            return decodedToken.exp * 1000;
        } catch (error) {
            return null;
        }
    },
    isExpired: function(token) {
        return Date.now() > this.getTokenExpirationTimestamp(token)
    },
}
export default jwt;